<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center">
      Pelatihan Implementasi Risk Base
      <!-- <CButton color="primary" style="float:right;margin-right:10px" class="btn-md">Print</CButton> -->
      <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
      <CButton color="success" style="float:right;margin-right:10px" class="btn-md">Tambah</CButton>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/finance/payment"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Payment Gateway</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/keanggotaan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Keanggotaan</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/sertifikasi"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Sertifikasi</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/finance/pelatihan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          style="background-color: #486ba7;"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Pelatihan</router-link>
      </li>
    </ul>
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol sm="6" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template #_status="{item}">
              <td class="py-2">
                <i class="fa fa-check text-success" aria-hidden="true" v-if="item._status == 1"></i>
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2">
                <CButton color="success" class="btn-sm text-white" square @click="myModal = true">
                  <font-awesome-icon icon="coins" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Diverifikai Pada" />
            </CCol>
            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" class="custom-control-input" name="customRadio" id="aktif" />
                  <label class="custom-control-label" for="aktif">Terverifikasi</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Persyaratan Dokumen</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
const items = [
  {
    id: "1405",
    no_agt: "3786",
    tipe_member: "CPA Selain Pemegang Izin AP",
    nama_lenkap: "ERNA SURYA NINGSIH",
    tgl_transfer: "2019-06-19",
    verif_pada: "2019-06-19",
    biaya: "Rp. 300.000",
    bukti: "bukti.jpg",
    _status: 0
  }
];

const fields = [
  {
    key: "id",
    label: "ID",
    sorter: true,
    filter: false
  },
  {
    key: "no_agt",
    label: "No. AGT",
    sorter: true,
    filter: false
  },
  {
    key: "tipe_member",
    label: "Tipe Member",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: false
  },
  {
    key: "tgl_trasnfer",
    label: "Tanggal Transfer",
    sorter: true,
    filter: false
  },
  {
    key: "verif_pada",
    label: "Diverifikasi Pada",
    sorter: true,
    filter: false
  },
  {
    key: "biaya",
    label: "Biaya",
    sorter: true,
    filter: false
  },
  {
    key: "bukti",
    label: "Bukti Transfer",
    sorter: true,
    filter: false
  },
  {
    key: "_status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>